import React from 'react';
export function Footer() {
  return <footer className="py-8 sm:py-10 px-4 border-t border-brand-sage/20 bg-brand-cream text-center text-brand-text-muted text-xs sm:text-sm font-medium" data-id="element-79">
      <div className="max-w-xl mx-auto space-y-4" data-id="element-80">
        <p className="text-brand-olive font-bold uppercase tracking-wider" data-id="element-81">
          METABOLIK PRO
        </p>
        <p className="leading-relaxed text-xs" data-id="element-82">
          Informations- und Bildungszwecke. Kein Ersatz für medizinischen Rat.
        </p>
        <div className="flex justify-center gap-4 text-xs mt-4" data-id="element-83">
          <a href="#" className="hover:text-brand-olive" data-id="element-84">
            AGB
          </a>
          <span data-id="element-85">·</span>
          <a href="#" className="hover:text-brand-olive" data-id="element-86">
            Datenschutz
          </a>
          <span data-id="element-87">·</span>
          <a href="#" className="hover:text-brand-olive" data-id="element-88">
            Kontakt
          </a>
        </div>
        <p className="text-[10px] sm:text-xs text-brand-text-muted/70 mt-6" data-id="element-89">
          © 2026 Metabolik Pro — Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}